import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {IdexService} from '../../idex.service';
import {AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import {AuthGuard} from '../../auth-guard.service';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {Toast} from '../../shared/toast/toast';
import {LoadingButtonComponent} from '../../shared/loading-button/button';
import { TranslateService } from '@ngx-translate/core';

@Component({
   selector: 'app-watermark',
   templateUrl: './watermark.component.html',
   styleUrls: ['./watermark.component.css']
})
export class WatermarkComponent implements OnInit, AfterViewInit {

   @ViewChild('previewCanvas', {static: false}) canvas!: ElementRef;
   @ViewChild('input') input: ElementRef;
   context: CanvasRenderingContext2D | undefined;
   total: any;
   error: any;
   applyWatermark = false;
   watermark = new Watermark();
   form: FormGroup;
   watermarkForm: FormGroup;
   prefixValue = PREFIX;
   disabledSave = false;
   disabledButton = false;
   colors = [
      {value: '#000000', viewValue: 'Black'},
      {value: '#808080', viewValue: 'Gray'},
      {value: '#33BBE6', viewValue: 'Blue'},
      {value: '#E6261F', viewValue: 'Red'},
      {value: '#519A64', viewValue: 'Green'},

   ];
   fontSizes = [18, 20, 22, 24, 26, 28, 30, 35, 40, 45, 50, 55, 60];
   opacities = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50];

   public siteCode: string;

   constructor(private service: IdexService, private auth: AuthGuard, private fb: FormBuilder, private api: IdexService, public dialog: MatDialog, private toast: Toast
      , private translate: TranslateService) {
      this.watermarkForm = this.fb.group({
         prefix: [this.watermark.prefix, [Validators.required]],
         textWatermark: [this.watermark.textWatermark,[Validators.required]],
         fontStyle: [this.watermark.fontFamily, [Validators.required]],
         color: [this.watermark.color, [Validators.required]],
         size: [this.watermark.fontSize, [Validators.required]],
         opacity: [this.watermark.opacity, [Validators.required]],
      }, {validators: this.validateText()});
   }

   ngOnInit(): void {
      this.siteCode = window.localStorage.getItem('tin');
      this.getWatermark();
   }

   ngAfterViewInit(): void {
      this.context = this.canvas.nativeElement.getContext('2d');
      this.watermarkForm.valueChanges.subscribe(() => {
         this.draw();
      });
   }

   validateText(): ValidatorFn {
      return (control: AbstractControl): ValidationErrors | null => {
         const prefix = control.get('prefix');
         const text = control.get('textWatermark');
         if (prefix?.value === 'None' && text?.value === '') {
            text.markAsUntouched();
            text.setErrors({required: true});
            return {validateText: true};
         } else {
            text?.setErrors(null);
         }
         return null;
      };
   }

   getWatermark() {
      this.api.getWatermarkBySite(this.siteCode).subscribe(result => {
         if (result) {
            this.applyWatermark = true;
            this.watermark.prefix = result.prefix;
            this.watermark.textWatermark = result.textWatermark || '';
            this.watermark.fontSize = result.fontSize;
            this.watermark.color = result.color;
            this.watermark.opacity = result.opacity;
         } else {
            this.applyWatermark = false;
            this.watermark.prefix = PREFIX.fullName;
            this.watermark.textWatermark = '';
            this.watermark.fontSize = 18;
            this.watermark.color = '#E6261F';
            this.watermark.opacity = 20;
         }
         this.watermarkForm.controls.prefix.setValue(this.watermark.prefix);
         this.watermarkForm.controls.textWatermark.setValue(this.watermark.textWatermark);
         this.watermarkForm.controls.fontStyle.setValue(this.watermark.fontFamily);
         this.watermarkForm.controls.color.setValue(this.watermark.color);
         this.watermarkForm.controls.size.setValue(this.watermark.fontSize);
         this.watermarkForm.controls.opacity.setValue(this.watermark.opacity);
      }, error => {
         this.error = error;
      });
   }

   setDefaultValueWatermark(): void {
      this.applyWatermark = false;
      this.watermark.prefix = PREFIX.fullName;
      this.watermark.textWatermark = '';
      this.watermark.fontSize = 18;
      this.watermark.color = '#E6261F';
      this.watermark.opacity = 20;
      this.watermarkForm.controls.prefix.setValue(this.watermark.prefix);
      this.watermarkForm.controls.textWatermark.setValue(this.watermark.textWatermark);
      this.watermarkForm.controls.fontStyle.setValue(this.watermark.fontFamily);
      this.watermarkForm.controls.color.setValue(this.watermark.color);
      this.watermarkForm.controls.size.setValue(this.watermark.fontSize);
      this.watermarkForm.controls.opacity.setValue(this.watermark.opacity);
   }

   onSave(): void {
      if (this.watermarkForm.valid || !this.applyWatermark) {
         this.disabledButton = true;
         this.service.getWatermarkBySite(this.siteCode)
            .subscribe(async _ => {
                  try {
                     if (this.applyWatermark) {
                        await this.updateWatermark();
                     } else {
                        this.setDefaultValueWatermark();
                        await this.deleteWatermark();
                     }
                     this.translate.get('watermark.save_success').subscribe(s => {
                        this.toast.success(s);
                     });
                     this.disabledButton = false;
                  } catch (error) {
                     this.error = error;
                     this.disabledButton = false;
                  }
               },
               error2 => {
                  this.error = error2;
                  this.disabledButton = false;
            });
      }
   }

   onSaveApply(input: any): void {
      this.disabledButton = true;
      if (this.watermarkForm.value.prefix === 'None'){
         // const value = input.nativeElement.value.trim();
         const value = this.watermarkForm.value.textWatermark;
         if (value.length === 0) {
            // input.nativeElement.focus();
            this.watermarkForm.get('textWatermark').markAsTouched();
            this.disabledButton = false;
            return;
         }
         this.disabledButton = false;
      }
      if (this.watermarkForm.valid && this.applyWatermark) {
         this.service.getWatermarkBySite(this.siteCode)
            .subscribe(async _ => {
                  try {
                     await this.updateWatermark();
                     this.translate.get('watermark.save_success').subscribe(s => {
                        this.toast.success(s);
                     });
                     this.disabledButton = false;
                  } catch (error) {
                     this.error = error;
                     this.disabledButton = false;
                  }
               },
               error2 => {
                  this.error = error2;
                  this.disabledButton = false;
            });
      } else {
         this.disabledButton = false;
      }
   }

   updateWatermark() {
      return new Promise<void>((resolve, reject) => {
         const data = {
            prefix: this.watermarkForm.value.prefix,
            textWatermark: this.watermarkForm.value.textWatermark,
            color: this.watermarkForm.value.color,
            fontSize: this.watermarkForm.value.size,
            opacity: this.watermarkForm.value.opacity,
         };
         this.api.updateWatermark(this.siteCode, data).subscribe(() => {
            resolve();
         }, error => {
            reject(error);
         });
      });
   }

   deleteWatermark() {
      return new Promise<void>((resolve, reject) => {
         this.api.deleteWatermark(this.siteCode).subscribe(() => {
            resolve();
         }, error => {
            reject(error);
         });
      });
   }

   getPrefixText(prefix: string): string {
      let text: string;
      switch (prefix) {
         case PREFIX.fullName:
            text = `${this.service.user.name}`.trim();
            break;
         case PREFIX.email:
            text = this.service.user.email;
            break;
         default :
            text = '';
            break;
      }
      return text;
   }

   private draw() {
      if (this.context !== undefined) {
         const originW = this.canvas.nativeElement.width;
         const originH = this.canvas.nativeElement.height;
         const config = this.watermarkForm.value;
         const prefixText = `${this.getPrefixText(config.prefix)} ${config.textWatermark}`;
         this.context.clearRect(0, 0, this.canvas.nativeElement.width, this.canvas.nativeElement.height);
         this.context.font = `${config.size}px ${config.fontStyle}`;
         this.context.textBaseline = 'middle';
         this.context.fillStyle = `${config.color}`;
         this.context.globalAlpha = config.opacity / 100;
         this.context.save();
         this.context.translate(originW / 2, originH / 2);
         this.context.rotate(-Math.atan(originH / originW));
         this.context.textAlign = 'center';
         this.context.fillText(prefixText, 0, (config.size / 2) - 15);
         this.context.restore();
      }
   }

   radioChange(e: any): void {
      this.disabledSave = (e.value === 'None') && this.watermarkForm.controls.textWatermark.value.trim() === '';
   }
}

export const PREFIX = {
   fullName: 'Name',
   email: 'Email',
   none: 'None',
};

export class Watermark {
   prefix = PREFIX.email;
   textWatermark = '';
   color = '#000000';
   fontFamily = 'sans-serif';
   fontSize = 24;
   opacity = 25;
   position = 'CT';
}
